import { render, staticRenderFns } from "./sidebar-container.vue?vue&type=template&id=0f856e82&scoped=true&lang=pug&"
import script from "./sidebar-container.vue?vue&type=script&lang=ts&"
export * from "./sidebar-container.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar-container.vue?vue&type=style&index=0&id=0f856e82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f856e82",
  null
  
)

export default component.exports